module.exports = __webpack_public_path__ + "static/media/windsurfing_768.25c11cf9.webp";